import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e181f272 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _30cf573e = () => interopDefault(import('..\\pages\\article\\index.vue' /* webpackChunkName: "pages/article/index" */))
const _aaffe896 = () => interopDefault(import('..\\pages\\business-insight\\index.vue' /* webpackChunkName: "pages/business-insight/index" */))
const _90ceef58 = () => interopDefault(import('..\\pages\\clientStartPage.vue' /* webpackChunkName: "pages/clientStartPage" */))
const _4c98d39e = () => interopDefault(import('..\\pages\\deal-nav\\index.vue' /* webpackChunkName: "pages/deal-nav/index" */))
const _79e4f8e9 = () => interopDefault(import('..\\pages\\dishonestyRoster\\index.vue' /* webpackChunkName: "pages/dishonestyRoster/index" */))
const _1d12b525 = () => interopDefault(import('..\\pages\\document\\index.vue' /* webpackChunkName: "pages/document/index" */))
const _72c3fb19 = () => interopDefault(import('..\\pages\\everydayQuestion\\index.vue' /* webpackChunkName: "pages/everydayQuestion/index" */))
const _2db4aec8 = () => interopDefault(import('..\\pages\\focus\\index.vue' /* webpackChunkName: "pages/focus/index" */))
const _37293152 = () => interopDefault(import('..\\pages\\intelQueAnswer\\index.vue' /* webpackChunkName: "pages/intelQueAnswer/index" */))
const _f2703b4e = () => interopDefault(import('..\\pages\\library\\index.vue' /* webpackChunkName: "pages/library/index" */))
const _656b796b = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _25061cd3 = () => interopDefault(import('..\\pages\\msg\\index.vue' /* webpackChunkName: "pages/msg/index" */))
const _21180670 = () => interopDefault(import('..\\pages\\notice\\index.vue' /* webpackChunkName: "pages/notice/index" */))
const _31cf5464 = () => interopDefault(import('..\\pages\\notice-detail\\index.vue' /* webpackChunkName: "pages/notice-detail/index" */))
const _0304384c = () => interopDefault(import('..\\pages\\polymerize\\index.vue' /* webpackChunkName: "pages/polymerize/index" */))
const _5954973d = () => interopDefault(import('..\\pages\\punishmentCase\\index.vue' /* webpackChunkName: "pages/punishmentCase/index" */))
const _3ae99d90 = () => interopDefault(import('..\\pages\\qa\\index.vue' /* webpackChunkName: "pages/qa/index" */))
const _385f8138 = () => interopDefault(import('..\\pages\\recommend\\index.vue' /* webpackChunkName: "pages/recommend/index" */))
const _0faacbf8 = () => interopDefault(import('..\\pages\\search\\index.vue' /* webpackChunkName: "pages/search/index" */))
const _794a237a = () => interopDefault(import('..\\pages\\standard\\index.vue' /* webpackChunkName: "pages/standard/index" */))
const _4b263866 = () => interopDefault(import('..\\pages\\template\\index.vue' /* webpackChunkName: "pages/template/index" */))
const _7bf455ce = () => interopDefault(import('..\\pages\\video\\index.vue' /* webpackChunkName: "pages/video/index" */))
const _77010089 = () => interopDefault(import('..\\pages\\viewpoint\\index.vue' /* webpackChunkName: "pages/viewpoint/index" */))
const _078fad86 = () => interopDefault(import('..\\pages\\windowsClient\\index.vue' /* webpackChunkName: "pages/windowsClient/index" */))
const _5f0fc5a4 = () => interopDefault(import('..\\pages\\businessIntelligence\\agent\\index.vue' /* webpackChunkName: "pages/businessIntelligence/agent/index" */))
const _2e22d920 = () => interopDefault(import('..\\pages\\businessIntelligence\\candidate\\index.vue' /* webpackChunkName: "pages/businessIntelligence/candidate/index" */))
const _301c9a8c = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\index.vue' /* webpackChunkName: "pages/businessIntelligence/invest/index" */))
const _23fcd366 = () => interopDefault(import('..\\pages\\businessIntelligence\\tender\\index.vue' /* webpackChunkName: "pages/businessIntelligence/tender/index" */))
const _d81110d0 = () => interopDefault(import('..\\pages\\businessIntelligence\\thematic\\index.vue' /* webpackChunkName: "pages/businessIntelligence/thematic/index" */))
const _33be0c0c = () => interopDefault(import('..\\pages\\deal-nav\\bid-review.vue' /* webpackChunkName: "pages/deal-nav/bid-review" */))
const _4bb3b00c = () => interopDefault(import('..\\pages\\deal-nav\\cabl.vue' /* webpackChunkName: "pages/deal-nav/cabl" */))
const _dcd71f7e = () => interopDefault(import('..\\pages\\deal-nav\\calculter.vue' /* webpackChunkName: "pages/deal-nav/calculter" */))
const _088982d6 = () => interopDefault(import('..\\pages\\deal-nav\\calculterOld.vue' /* webpackChunkName: "pages/deal-nav/calculterOld" */))
const _420ee131 = () => interopDefault(import('..\\pages\\deal-nav\\jyzx.vue' /* webpackChunkName: "pages/deal-nav/jyzx" */))
const _59d6ddb3 = () => interopDefault(import('..\\pages\\deal-nav\\third.vue' /* webpackChunkName: "pages/deal-nav/third" */))
const _5f0b3ebd = () => interopDefault(import('..\\pages\\everydayQuestion\\questionInfo.vue' /* webpackChunkName: "pages/everydayQuestion/questionInfo" */))
const _0bb8293e = () => interopDefault(import('..\\pages\\intelQueAnswer\\indexback.vue' /* webpackChunkName: "pages/intelQueAnswer/indexback" */))
const _01dd809c = () => interopDefault(import('..\\pages\\library\\documentInfo.vue' /* webpackChunkName: "pages/library/documentInfo" */))
const _69915ff6 = () => interopDefault(import('..\\pages\\punishmentCase\\detail.vue' /* webpackChunkName: "pages/punishmentCase/detail" */))
const _4a984b34 = () => interopDefault(import('..\\pages\\search\\article\\index.vue' /* webpackChunkName: "pages/search/article/index" */))
const _a082d206 = () => interopDefault(import('..\\pages\\search\\document\\index.vue' /* webpackChunkName: "pages/search/document/index" */))
const _a58c7d30 = () => interopDefault(import('..\\pages\\search\\qa\\index.vue' /* webpackChunkName: "pages/search/qa/index" */))
const _7e010241 = () => interopDefault(import('..\\pages\\search\\video\\index.vue' /* webpackChunkName: "pages/search/video/index" */))
const _39d159b1 = () => interopDefault(import('..\\pages\\search\\viewpoint\\index.vue' /* webpackChunkName: "pages/search/viewpoint/index" */))
const _34f35e77 = () => interopDefault(import('..\\pages\\user\\answer\\index.vue' /* webpackChunkName: "pages/user/answer/index" */))
const _86d8e4dc = () => interopDefault(import('..\\pages\\user\\assets\\index.vue' /* webpackChunkName: "pages/user/assets/index" */))
const _6b302ed5 = () => interopDefault(import('..\\pages\\user\\collect\\index.vue' /* webpackChunkName: "pages/user/collect/index" */))
const _33828300 = () => interopDefault(import('..\\pages\\user\\comment\\index.vue' /* webpackChunkName: "pages/user/comment/index" */))
const _0883fcad = () => interopDefault(import('..\\pages\\user\\download\\index.vue' /* webpackChunkName: "pages/user/download/index" */))
const _4ab6452b = () => interopDefault(import('..\\pages\\user\\history\\index.vue' /* webpackChunkName: "pages/user/history/index" */))
const _516993d8 = () => interopDefault(import('..\\pages\\user\\message\\index.vue' /* webpackChunkName: "pages/user/message/index" */))
const _00115b71 = () => interopDefault(import('..\\pages\\user\\order\\index.vue' /* webpackChunkName: "pages/user/order/index" */))
const _764dde8c = () => interopDefault(import('..\\pages\\user\\password\\index.vue' /* webpackChunkName: "pages/user/password/index" */))
const _25448665 = () => interopDefault(import('..\\pages\\user\\qa\\index.vue' /* webpackChunkName: "pages/user/qa/index" */))
const _67ae2422 = () => interopDefault(import('..\\pages\\user\\setting\\index.vue' /* webpackChunkName: "pages/user/setting/index" */))
const _297a7fb8 = () => interopDefault(import('..\\pages\\user\\video\\index.vue' /* webpackChunkName: "pages/user/video/index" */))
const _db2923d8 = () => interopDefault(import('..\\pages\\user\\viewpoint\\index.vue' /* webpackChunkName: "pages/user/viewpoint/index" */))
const _1707dd9a = () => interopDefault(import('..\\pages\\video\\detail.vue' /* webpackChunkName: "pages/video/detail" */))
const _4db07445 = () => interopDefault(import('..\\pages\\businessIntelligence\\agent\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/agent/Detail" */))
const _7efd3f72 = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\CityDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/CityDetail" */))
const _1148149a = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\DeepDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/DeepDetail" */))
const _473b35b6 = () => interopDefault(import('..\\pages\\businessIntelligence\\invest\\IndustryDetail.vue' /* webpackChunkName: "pages/businessIntelligence/invest/IndustryDetail" */))
const _3d53c1f4 = () => interopDefault(import('..\\pages\\businessIntelligence\\tender\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/tender/Detail" */))
const _0bc731ca = () => interopDefault(import('..\\pages\\businessIntelligence\\thematic\\Detail.vue' /* webpackChunkName: "pages/businessIntelligence/thematic/Detail" */))
const _5448726e = () => interopDefault(import('..\\pages\\deal-nav\\config\\rate.js' /* webpackChunkName: "pages/deal-nav/config/rate" */))
const _2285a7ec = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\deal-center-info.vue' /* webpackChunkName: "pages/deal-nav/seciton/deal-center-info" */))
const _9b5a0430 = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\main-bottom.vue' /* webpackChunkName: "pages/deal-nav/seciton/main-bottom" */))
const _5bdf0b12 = () => interopDefault(import('..\\pages\\deal-nav\\seciton\\main-center.vue' /* webpackChunkName: "pages/deal-nav/seciton/main-center" */))
const _619df430 = () => interopDefault(import('..\\pages\\search\\config\\nav.js' /* webpackChunkName: "pages/search/config/nav" */))
const _462c2d4c = () => interopDefault(import('..\\pages\\search\\mixins\\main.js' /* webpackChunkName: "pages/search/mixins/main" */))
const _ea053592 = () => interopDefault(import('..\\pages\\user\\assets\\explain.vue' /* webpackChunkName: "pages/user/assets/explain" */))
const _8c778d46 = () => interopDefault(import('..\\pages\\user\\assets\\vip.vue' /* webpackChunkName: "pages/user/assets/vip" */))
const _10f41ab2 = () => interopDefault(import('..\\pages\\library\\assets\\js\\news.js' /* webpackChunkName: "pages/library/assets/js/news" */))
const _42830e56 = () => interopDefault(import('..\\pages\\notice\\assets\\js\\news.js' /* webpackChunkName: "pages/notice/assets/js/news" */))
const _a0a67230 = () => interopDefault(import('..\\pages\\polymerize\\assets\\js\\news.js' /* webpackChunkName: "pages/polymerize/assets/js/news" */))
const _12eb433a = () => interopDefault(import('..\\pages\\user\\assets\\icon\\coin.vue' /* webpackChunkName: "pages/user/assets/icon/coin" */))
const _1155d08e = () => interopDefault(import('..\\pages\\user\\assets\\icon\\score.vue' /* webpackChunkName: "pages/user/assets/icon/score" */))
const _1411e9f5 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\ticket.vue' /* webpackChunkName: "pages/user/assets/icon/ticket" */))
const _c04cea3e = () => interopDefault(import('..\\pages\\user\\assets\\icon\\ticket-special.vue' /* webpackChunkName: "pages/user/assets/icon/ticket-special" */))
const _0b5325e2 = () => interopDefault(import('..\\pages\\user\\assets\\icon\\wechat.vue' /* webpackChunkName: "pages/user/assets/icon/wechat" */))
const _3374c4c0 = () => interopDefault(import('..\\pages\\user\\message\\mixins\\item.js' /* webpackChunkName: "pages/user/message/mixins/item" */))
const _72fb7835 = () => interopDefault(import('..\\pages\\user\\message\\mixins\\list.js' /* webpackChunkName: "pages/user/message/mixins/list" */))
const _656a8aca = () => interopDefault(import('..\\pages\\user\\assets\\icon\\mixins\\main.js' /* webpackChunkName: "pages/user/assets/icon/mixins/main" */))
const _7d04e3c1 = () => interopDefault(import('..\\pages\\qa\\special\\_guid.vue' /* webpackChunkName: "pages/qa/special/_guid" */))
const _e73d1e78 = () => interopDefault(import('..\\pages\\viewpoint\\topic\\_id.vue' /* webpackChunkName: "pages/viewpoint/topic/_id" */))
const _17fe42d4 = () => interopDefault(import('..\\pages\\article\\_guid.vue' /* webpackChunkName: "pages/article/_guid" */))
const _0441a0bb = () => interopDefault(import('..\\pages\\document\\_guid.vue' /* webpackChunkName: "pages/document/_guid" */))
const _6df6cdef = () => interopDefault(import('..\\pages\\library\\_guid.vue' /* webpackChunkName: "pages/library/_guid" */))
const _22188926 = () => interopDefault(import('..\\pages\\qa\\_guid.vue' /* webpackChunkName: "pages/qa/_guid" */))
const _ad967ea2 = () => interopDefault(import('..\\pages\\video\\_guid.vue' /* webpackChunkName: "pages/video/_guid" */))
const _5e2fec1f = () => interopDefault(import('..\\pages\\viewpoint\\_guid.vue' /* webpackChunkName: "pages/viewpoint/_guid" */))
const _be8207c0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _31db6144 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\dishonesty-name.vue' /* webpackChunkName: "pages/index/compoentsNew/dishonesty-name" */))
const _0336a3d8 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\hot-new.vue' /* webpackChunkName: "pages/index/compoentsNew/hot-new" */))
const _a0fdc952 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\intelligent-answers.vue' /* webpackChunkName: "pages/index/compoentsNew/intelligent-answers" */))
const _68987627 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\latest-answers.vue' /* webpackChunkName: "pages/index/compoentsNew/latest-answers" */))
const _54a51cf1 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\library-box.vue' /* webpackChunkName: "pages/index/compoentsNew/library-box" */))
const _07276e68 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\notice-publicity.vue' /* webpackChunkName: "pages/index/compoentsNew/notice-publicity" */))
const _fcb0876a = () => interopDefault(import('..\\pages\\index\\compoentsNew\\policy-regulatory.vue' /* webpackChunkName: "pages/index/compoentsNew/policy-regulatory" */))
const _c1fdbd7c = () => interopDefault(import('..\\pages\\index\\compoentsNew\\popular-searches.vue' /* webpackChunkName: "pages/index/compoentsNew/popular-searches" */))
const _75c865b1 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\puishment-demo.vue' /* webpackChunkName: "pages/index/compoentsNew/puishment-demo" */))
const _76adbc2a = () => interopDefault(import('..\\pages\\index\\compoentsNew\\standard-specification.vue' /* webpackChunkName: "pages/index/compoentsNew/standard-specification" */))
const _0098fdf0 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\swiper.vue' /* webpackChunkName: "pages/index/compoentsNew/swiper" */))
const _6ec5ee8e = () => interopDefault(import('..\\pages\\index\\compoentsNew\\tool-box.vue' /* webpackChunkName: "pages/index/compoentsNew/tool-box" */))
const _01ea14b1 = () => interopDefault(import('..\\pages\\index\\compoentsNew\\video-box.vue' /* webpackChunkName: "pages/index/compoentsNew/video-box" */))
const _1e9f4d70 = () => interopDefault(import('..\\pages\\index\\assets\\js\\news.js' /* webpackChunkName: "pages/index/assets/js/news" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _e181f272,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/article",
    component: _30cf573e,
    alias: "/article/index.html",
    name: "article"
  }, {
    path: "/business-insight",
    component: _aaffe896,
    alias: "/business-insight/index.html",
    name: "business-insight"
  }, {
    path: "/clientStartPage",
    component: _90ceef58,
    alias: "/clientStartPage/index.html",
    name: "clientStartPage"
  }, {
    path: "/deal-nav",
    component: _4c98d39e,
    alias: "/deal-nav/index.html",
    name: "deal-nav"
  }, {
    path: "/dishonestyRoster",
    component: _79e4f8e9,
    alias: "/dishonestyRoster/index.html",
    name: "dishonestyRoster"
  }, {
    path: "/document",
    component: _1d12b525,
    alias: "/document/index.html",
    name: "document"
  }, {
    path: "/everydayQuestion",
    component: _72c3fb19,
    alias: "/everydayQuestion/index.html",
    name: "everydayQuestion"
  }, {
    path: "/focus",
    component: _2db4aec8,
    alias: "/focus/index.html",
    name: "focus"
  }, {
    path: "/intelQueAnswer",
    component: _37293152,
    alias: "/intelQueAnswer/index.html",
    name: "intelQueAnswer"
  }, {
    path: "/library",
    component: _f2703b4e,
    alias: "/library/index.html",
    name: "library"
  }, {
    path: "/login",
    component: _656b796b,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/msg",
    component: _25061cd3,
    alias: "/msg/index.html",
    name: "msg"
  }, {
    path: "/notice",
    component: _21180670,
    alias: "/notice/index.html",
    name: "notice"
  }, {
    path: "/notice-detail",
    component: _31cf5464,
    alias: "/notice-detail/index.html",
    name: "notice-detail"
  }, {
    path: "/polymerize",
    component: _0304384c,
    alias: "/polymerize/index.html",
    name: "polymerize"
  }, {
    path: "/punishmentCase",
    component: _5954973d,
    alias: "/punishmentCase/index.html",
    name: "punishmentCase"
  }, {
    path: "/qa",
    component: _3ae99d90,
    alias: "/qa/index.html",
    name: "qa"
  }, {
    path: "/recommend",
    component: _385f8138,
    alias: "/recommend/index.html",
    name: "recommend"
  }, {
    path: "/search",
    component: _0faacbf8,
    alias: "/search/index.html",
    name: "search"
  }, {
    path: "/standard",
    component: _794a237a,
    alias: "/standard/index.html",
    name: "standard"
  }, {
    path: "/template",
    component: _4b263866,
    alias: "/template/index.html",
    name: "template"
  }, {
    path: "/video",
    component: _7bf455ce,
    alias: "/video/index.html",
    name: "video"
  }, {
    path: "/viewpoint",
    component: _77010089,
    alias: "/viewpoint/index.html",
    name: "viewpoint"
  }, {
    path: "/windowsClient",
    component: _078fad86,
    alias: "/windowsClient/index.html",
    name: "windowsClient"
  }, {
    path: "/businessIntelligence/agent",
    component: _5f0fc5a4,
    alias: "/businessIntelligence/agent/index.html",
    name: "businessIntelligence-agent"
  }, {
    path: "/businessIntelligence/candidate",
    component: _2e22d920,
    alias: "/businessIntelligence/candidate/index.html",
    name: "businessIntelligence-candidate"
  }, {
    path: "/businessIntelligence/invest",
    component: _301c9a8c,
    alias: "/businessIntelligence/invest/index.html",
    name: "businessIntelligence-invest"
  }, {
    path: "/businessIntelligence/tender",
    component: _23fcd366,
    alias: "/businessIntelligence/tender/index.html",
    name: "businessIntelligence-tender"
  }, {
    path: "/businessIntelligence/thematic",
    component: _d81110d0,
    alias: "/businessIntelligence/thematic/index.html",
    name: "businessIntelligence-thematic"
  }, {
    path: "/deal-nav/bid-review",
    component: _33be0c0c,
    alias: "/deal-nav/bid-review/index.html",
    name: "deal-nav-bid-review"
  }, {
    path: "/deal-nav/cabl",
    component: _4bb3b00c,
    alias: "/deal-nav/cabl/index.html",
    name: "deal-nav-cabl"
  }, {
    path: "/deal-nav/calculter",
    component: _dcd71f7e,
    alias: "/deal-nav/calculter/index.html",
    name: "deal-nav-calculter"
  }, {
    path: "/deal-nav/calculterOld",
    component: _088982d6,
    alias: "/deal-nav/calculterOld/index.html",
    name: "deal-nav-calculterOld"
  }, {
    path: "/deal-nav/jyzx",
    component: _420ee131,
    alias: "/deal-nav/jyzx/index.html",
    name: "deal-nav-jyzx"
  }, {
    path: "/deal-nav/third",
    component: _59d6ddb3,
    alias: "/deal-nav/third/index.html",
    name: "deal-nav-third"
  }, {
    path: "/everydayQuestion/questionInfo",
    component: _5f0b3ebd,
    alias: "/everydayQuestion/questionInfo/index.html",
    name: "everydayQuestion-questionInfo"
  }, {
    path: "/intelQueAnswer/indexback",
    component: _0bb8293e,
    alias: "/intelQueAnswer/indexback/index.html",
    name: "intelQueAnswer-indexback"
  }, {
    path: "/library/documentInfo",
    component: _01dd809c,
    alias: "/library/documentInfo/index.html",
    name: "library-documentInfo"
  }, {
    path: "/punishmentCase/detail",
    component: _69915ff6,
    alias: "/punishmentCase/detail/index.html",
    name: "punishmentCase-detail"
  }, {
    path: "/search/article",
    component: _4a984b34,
    alias: "/search/article/index.html",
    name: "search-article"
  }, {
    path: "/search/document",
    component: _a082d206,
    alias: "/search/document/index.html",
    name: "search-document"
  }, {
    path: "/search/qa",
    component: _a58c7d30,
    alias: "/search/qa/index.html",
    name: "search-qa"
  }, {
    path: "/search/video",
    component: _7e010241,
    alias: "/search/video/index.html",
    name: "search-video"
  }, {
    path: "/search/viewpoint",
    component: _39d159b1,
    alias: "/search/viewpoint/index.html",
    name: "search-viewpoint"
  }, {
    path: "/user/answer",
    component: _34f35e77,
    alias: "/user/answer/index.html",
    name: "user-answer"
  }, {
    path: "/user/assets",
    component: _86d8e4dc,
    alias: "/user/assets/index.html",
    name: "user-assets"
  }, {
    path: "/user/collect",
    component: _6b302ed5,
    alias: "/user/collect/index.html",
    name: "user-collect"
  }, {
    path: "/user/comment",
    component: _33828300,
    alias: "/user/comment/index.html",
    name: "user-comment"
  }, {
    path: "/user/download",
    component: _0883fcad,
    alias: "/user/download/index.html",
    name: "user-download"
  }, {
    path: "/user/history",
    component: _4ab6452b,
    alias: "/user/history/index.html",
    name: "user-history"
  }, {
    path: "/user/message",
    component: _516993d8,
    alias: "/user/message/index.html",
    name: "user-message"
  }, {
    path: "/user/order",
    component: _00115b71,
    alias: "/user/order/index.html",
    name: "user-order"
  }, {
    path: "/user/password",
    component: _764dde8c,
    alias: "/user/password/index.html",
    name: "user-password"
  }, {
    path: "/user/qa",
    component: _25448665,
    alias: "/user/qa/index.html",
    name: "user-qa"
  }, {
    path: "/user/setting",
    component: _67ae2422,
    alias: "/user/setting/index.html",
    name: "user-setting"
  }, {
    path: "/user/video",
    component: _297a7fb8,
    alias: "/user/video/index.html",
    name: "user-video"
  }, {
    path: "/user/viewpoint",
    component: _db2923d8,
    alias: "/user/viewpoint/index.html",
    name: "user-viewpoint"
  }, {
    path: "/video/detail",
    component: _1707dd9a,
    alias: "/video/detail/index.html",
    name: "video-detail"
  }, {
    path: "/businessIntelligence/agent/Detail",
    component: _4db07445,
    alias: "/businessIntelligence/agent/Detail/index.html",
    name: "businessIntelligence-agent-Detail"
  }, {
    path: "/businessIntelligence/invest/CityDetail",
    component: _7efd3f72,
    alias: "/businessIntelligence/invest/CityDetail/index.html",
    name: "businessIntelligence-invest-CityDetail"
  }, {
    path: "/businessIntelligence/invest/DeepDetail",
    component: _1148149a,
    alias: "/businessIntelligence/invest/DeepDetail/index.html",
    name: "businessIntelligence-invest-DeepDetail"
  }, {
    path: "/businessIntelligence/invest/IndustryDetail",
    component: _473b35b6,
    alias: "/businessIntelligence/invest/IndustryDetail/index.html",
    name: "businessIntelligence-invest-IndustryDetail"
  }, {
    path: "/businessIntelligence/tender/Detail",
    component: _3d53c1f4,
    alias: "/businessIntelligence/tender/Detail/index.html",
    name: "businessIntelligence-tender-Detail"
  }, {
    path: "/businessIntelligence/thematic/Detail",
    component: _0bc731ca,
    alias: "/businessIntelligence/thematic/Detail/index.html",
    name: "businessIntelligence-thematic-Detail"
  }, {
    path: "/deal-nav/config/rate",
    component: _5448726e,
    alias: "/deal-nav/config/rate/index.html",
    name: "deal-nav-config-rate"
  }, {
    path: "/deal-nav/seciton/deal-center-info",
    component: _2285a7ec,
    alias: "/deal-nav/seciton/deal-center-info/index.html",
    name: "deal-nav-seciton-deal-center-info"
  }, {
    path: "/deal-nav/seciton/main-bottom",
    component: _9b5a0430,
    alias: "/deal-nav/seciton/main-bottom/index.html",
    name: "deal-nav-seciton-main-bottom"
  }, {
    path: "/deal-nav/seciton/main-center",
    component: _5bdf0b12,
    alias: "/deal-nav/seciton/main-center/index.html",
    name: "deal-nav-seciton-main-center"
  }, {
    path: "/search/config/nav",
    component: _619df430,
    alias: "/search/config/nav/index.html",
    name: "search-config-nav"
  }, {
    path: "/search/mixins/main",
    component: _462c2d4c,
    alias: "/search/mixins/main/index.html",
    name: "search-mixins-main"
  }, {
    path: "/user/assets/explain",
    component: _ea053592,
    alias: "/user/assets/explain/index.html",
    name: "user-assets-explain"
  }, {
    path: "/user/assets/vip",
    component: _8c778d46,
    alias: "/user/assets/vip/index.html",
    name: "user-assets-vip"
  }, {
    path: "/library/assets/js/news",
    component: _10f41ab2,
    alias: "/library/assets/js/news/index.html",
    name: "library-assets-js-news"
  }, {
    path: "/notice/assets/js/news",
    component: _42830e56,
    alias: "/notice/assets/js/news/index.html",
    name: "notice-assets-js-news"
  }, {
    path: "/polymerize/assets/js/news",
    component: _a0a67230,
    alias: "/polymerize/assets/js/news/index.html",
    name: "polymerize-assets-js-news"
  }, {
    path: "/user/assets/icon/coin",
    component: _12eb433a,
    alias: "/user/assets/icon/coin/index.html",
    name: "user-assets-icon-coin"
  }, {
    path: "/user/assets/icon/score",
    component: _1155d08e,
    alias: "/user/assets/icon/score/index.html",
    name: "user-assets-icon-score"
  }, {
    path: "/user/assets/icon/ticket",
    component: _1411e9f5,
    alias: "/user/assets/icon/ticket/index.html",
    name: "user-assets-icon-ticket"
  }, {
    path: "/user/assets/icon/ticket-special",
    component: _c04cea3e,
    alias: "/user/assets/icon/ticket-special/index.html",
    name: "user-assets-icon-ticket-special"
  }, {
    path: "/user/assets/icon/wechat",
    component: _0b5325e2,
    alias: "/user/assets/icon/wechat/index.html",
    name: "user-assets-icon-wechat"
  }, {
    path: "/user/message/mixins/item",
    component: _3374c4c0,
    alias: "/user/message/mixins/item/index.html",
    name: "user-message-mixins-item"
  }, {
    path: "/user/message/mixins/list",
    component: _72fb7835,
    alias: "/user/message/mixins/list/index.html",
    name: "user-message-mixins-list"
  }, {
    path: "/user/assets/icon/mixins/main",
    component: _656a8aca,
    alias: "/user/assets/icon/mixins/main/index.html",
    name: "user-assets-icon-mixins-main"
  }, {
    path: "/qa/special/:guid?",
    component: _7d04e3c1,
    alias: "/qa/special/:guid?/index.html",
    name: "qa-special-guid"
  }, {
    path: "/viewpoint/topic/:id?",
    component: _e73d1e78,
    alias: "/viewpoint/topic/:id?/index.html",
    name: "viewpoint-topic-id"
  }, {
    path: "/article/:guid",
    component: _17fe42d4,
    alias: "/article/:guid/index.html",
    name: "article-guid"
  }, {
    path: "/document/:guid",
    component: _0441a0bb,
    alias: "/document/:guid/index.html",
    name: "document-guid"
  }, {
    path: "/library/:guid",
    component: _6df6cdef,
    alias: "/library/:guid/index.html",
    name: "library-guid"
  }, {
    path: "/qa/:guid",
    component: _22188926,
    alias: "/qa/:guid/index.html",
    name: "qa-guid"
  }, {
    path: "/video/:guid",
    component: _ad967ea2,
    alias: "/video/:guid/index.html",
    name: "video-guid"
  }, {
    path: "/viewpoint/:guid",
    component: _5e2fec1f,
    alias: "/viewpoint/:guid/index.html",
    name: "viewpoint-guid"
  }, {
    path: "/",
    component: _be8207c0,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "compoentsNew/dishonesty-name",
      component: _31db6144,
      name: "index-compoentsNew-dishonesty-name"
    }, {
      path: "compoentsNew/hot-new",
      component: _0336a3d8,
      name: "index-compoentsNew-hot-new"
    }, {
      path: "compoentsNew/intelligent-answers",
      component: _a0fdc952,
      name: "index-compoentsNew-intelligent-answers"
    }, {
      path: "compoentsNew/latest-answers",
      component: _68987627,
      name: "index-compoentsNew-latest-answers"
    }, {
      path: "compoentsNew/library-box",
      component: _54a51cf1,
      name: "index-compoentsNew-library-box"
    }, {
      path: "compoentsNew/notice-publicity",
      component: _07276e68,
      name: "index-compoentsNew-notice-publicity"
    }, {
      path: "compoentsNew/policy-regulatory",
      component: _fcb0876a,
      name: "index-compoentsNew-policy-regulatory"
    }, {
      path: "compoentsNew/popular-searches",
      component: _c1fdbd7c,
      name: "index-compoentsNew-popular-searches"
    }, {
      path: "compoentsNew/puishment-demo",
      component: _75c865b1,
      name: "index-compoentsNew-puishment-demo"
    }, {
      path: "compoentsNew/standard-specification",
      component: _76adbc2a,
      name: "index-compoentsNew-standard-specification"
    }, {
      path: "compoentsNew/swiper",
      component: _0098fdf0,
      name: "index-compoentsNew-swiper"
    }, {
      path: "compoentsNew/tool-box",
      component: _6ec5ee8e,
      name: "index-compoentsNew-tool-box"
    }, {
      path: "compoentsNew/video-box",
      component: _01ea14b1,
      name: "index-compoentsNew-video-box"
    }, {
      path: "assets/js/news",
      component: _1e9f4d70,
      name: "index-assets-js-news"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
